import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Automation\GetAutomationModelConfigController::__invoke
* @see app/Http/Controllers/Automation/GetAutomationModelConfigController.php
* @route '/api/automation/config-model'
*/
const GetAutomationModelConfigController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAutomationModelConfigController.url(options),
    method: 'get',
})

GetAutomationModelConfigController.definition = {
    methods: ["get","head"],
    url: '/api/automation/config-model',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Automation\GetAutomationModelConfigController::__invoke
* @see app/Http/Controllers/Automation/GetAutomationModelConfigController.php
* @route '/api/automation/config-model'
*/
GetAutomationModelConfigController.url = (options?: RouteQueryOptions) => {
    return GetAutomationModelConfigController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Automation\GetAutomationModelConfigController::__invoke
* @see app/Http/Controllers/Automation/GetAutomationModelConfigController.php
* @route '/api/automation/config-model'
*/
GetAutomationModelConfigController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAutomationModelConfigController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Automation\GetAutomationModelConfigController::__invoke
* @see app/Http/Controllers/Automation/GetAutomationModelConfigController.php
* @route '/api/automation/config-model'
*/
GetAutomationModelConfigController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetAutomationModelConfigController.url(options),
    method: 'head',
})

export default GetAutomationModelConfigController